// extracted by mini-css-extract-plugin
export default {"mid":"Mid_mid__eg2ar","rightLine":"Mid_rightLine__xiQ8p"};